import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ApprovalCampListing from "./approvalCampListing";
import {
  getApprovalCampList,
  campApproval,
  campReject,
} from "services/redux/brandActivtion/conductCamp/action";

const mapStateToProps = (state) => ({
  campApprove: state.ConductCampReducer.campApprove,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getApprovalCampList,
      campApproval,
      campReject,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApprovalCampListing);
